/**
 * Rights rule for the Expertise (unlimitedTraining) subscription: a subscriber may only
 * have MAX_EXPERTISE_SLOTS trainings unlocked-via-subscription and not yet finished at once.
 *
 * A training counts against the rule when its program was unlocked via the subscription
 * (program.vendor.unlimitedUnlocked === true) and is not finished (vendor.hasFinished !== true).
 */
export const MAX_EXPERTISE_SLOTS = 2;

export const getExpertiseSlots = (baughtTraining: any[]) => {
  const used = (baughtTraining || []).filter(
    (b) => b?.programVendor?.unlimitedUnlocked === true && b?.programVendor?.hasFinished !== true,
  ).length;

  const remaining = Math.max(0, MAX_EXPERTISE_SLOTS - used);

  return { used, remaining, max: MAX_EXPERTISE_SLOTS };
};

export default getExpertiseSlots;
